import XPMotorApi from "@xpeng/xpmotors-jsbridge-api";
import * as Sentry from "@sentry/browser";
import moment from "moment";
import Cookie from "js-cookie";
import bridge from "@xpeng/js-bridge";
import Report from "@xpeng/report-js";
import unionAxios from "./union-axios";
import axios from "axios";
import { TArea } from "../components/city-picker";
import Toast from "../components/toast";
import OSS from "ali-oss";
import { getToken } from "../api/pile-apply";

const UA = navigator.userAgent || "";
const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
const isWX = /micromessenger/i.test(UA); // 微信
const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序

/**
 * transformToQueryUrl: 将url转换成查询参数类型的url
 * @param url {string}
 * @param params {object}
 * @returns {string}
 */
export function transformToQueryUrl(url: string, params: any): string {
  let query = "";
  if (params && Object.keys(params).length > 0) {
    query = "?";
    let count = 1;
    for (let ele in params) {
      if (count < Object.keys(params).length) {
        query += ele + "=" + params[ele] + "&";
        count++;
      } else {
        query += ele + "=" + params[ele];
      }
    }
  }
  return url + query;
}

/**
 * 根据传入url及传递参数，跳转到对应的网页
 * @param {string} url 路径
 * @param {*} params 参数
 */
export function openUrl(url: string, params?: any, target?: string): void {
  console.log("url", url);

  var el = document.createElement("a");
  document.body.appendChild(el);
  el.href = transformToQueryUrl(url, params);
  el.target = target ? "_self" : "_blank";

  var e = document.createEvent("MouseEvents");
  e.initEvent("click", true, true);
  el.dispatchEvent(e);
  document.body.removeChild(el);
}

/**
 * 获取window.location.search的参数，返回一个对象，通过参数名获取值
 * @returns {object}
 */
export function getQueryObj(customSearch?: string): any {
  /* const params = new URLSearchParams(window.location.search);
  const obj: any = {};
  for (const key of params.keys()) {
    const vals = params.getAll(key);
    if (vals.length === 1) {
      obj[key] = vals[0];
    } else {
      obj[key] = vals;
    }
  }
  return obj; */
  const obj: any = {};
  let searchParams;
  if (customSearch) {
    searchParams = customSearch.substr(1);
  } else {
    searchParams = window.location.search.substr(1);
  }
  const params = searchParams.split("&");
  params.forEach(str => {
    const arr = str.split("=");
    if (arr[0] && arr[1]) {
      obj[arr[0]] = `${arr[1]}`;
    }
  });
  return obj;
}
/**
 * 平民版深拷贝对象方法
 * @param obj 被拷贝对象
 */
export function objectClone(obj: object): object {
  return JSON.parse(JSON.stringify(obj));
}

/**
 * 获取用户登录状态
 * (2024-11-28)这个方法本身依赖APP的jsbridge，但由于用到的页面需要投放在小程序和其他浏览器，为了兼容数据返回，用现有的web-h5接口包装成与bridge接口返回数据一致的数据结构以作兼容
 * 为了防止外部调用时没做catch，这里全部响应情况都resolve，没有data时resolve(false)
 */
export function getLoginInfoPromise(): Promise<any> {
  if (isXPApp) {
    return new Promise((resolve, reject): void => {
      XPMotorApi.getSdk()
        .callHandler("getLoginState", {})
        .then((res: any): void => {
          // loginState: true / false
          // data: {uid,username,avatar,mobile,carownerflag} | {}
          if (!res.loginState) {
            resolve(false);
          } else {
            resolve({
              ...res.data,
              nickName: res.data?.nickname || res.data?.username || ""
            });
          }
        })
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        .catch(err => {
          reject(err);
        });
    });
  }

  return new Promise<any>(resolve => {
    unionAxios
      .get(`/web-h5/user/queryCurrentUserBasicInfo`)
      .then(res => {
        if (res.code === 200) {
          const data = res.data || {};
          const formatData = {
            uid: data.uid,
            mobile: data.mobile,
            nickName: data.nickName,
            nickname: data.nickName,
            username: data.nickName,
            avatar: data.headImg
          };
          resolve(formatData);
        } else {
          resolve(false);
        }
      })
      .catch(err => {
        resolve(false);
      });
  });
}

/**
 * 跳到登录页面
 */
export function goToLogin(): Promise<any> {
  return new Promise((resolve, reject): void => {
    XPMotorApi.getSdk()
      .callHandler("goToNativePage", {
        bizType: "charge-web",
        pageType: "login",
        transitionType: 0,
        data: {
          direct: window.location.href
        }
      })
      .then(res => {
        // code:1登录成功 0取消登录
        resolve(!!res.code);
      })
      .catch(err => {
        reject(err);
      });
  });
}
/**
 * 根据当前登录态强行进入登录界面，如果拒绝登录则刷新页面，重新进入页面。
 */
export function go2LoginIfNot(): Promise<any> {
  return new Promise((resolve, reject): void => {
    getLoginInfoPromise()
      .then((loginData: any): void => {
        console.log(loginData, "用户信息");
        if (!loginData) {
          goToLogin().then(success => {
            if (!success) {
              resolve(false);
            } else {
              console.log("页面刷新--", window.location);
              // window.location.reload();
              resolve(true);
            }
          });
        } else {
          resolve(loginData);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 适配跳页面
 * @param url 需要跳转的地址
 * @param innerData 内部协议需要独立传参
 */
export function jumpPage(url: string, innerData: any = {}): void {
  if (
    url.indexOf("http://") === 0 ||
    url.indexOf("https://") === 0 ||
    url.indexOf("./") === 0
  ) {
    // 增加延迟 用于上报数据
    setTimeout(() => {
      window.location.href = url;
    }, 300);
  } else {
    XPMotorApi.getSdk().callHandler("openUrl", {
      url,
      data: innerData
    });
  }
}

/**
 * 获取当前平台：android还是iOS
 */
export function getPlatform() {
  let u = navigator.userAgent;
  console.log(u, "userAgent");
  let isAndroid =
    u.indexOf("Android") > -1 ||
    u.indexOf("Harmony") > -1 ||
    u.indexOf("Adr") > -1; //判断是否是 android终端
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
  console.log("是否是Android：" + isAndroid); //true,false
  console.log("是否是iOS：" + isIOS);
  if (isAndroid) {
    return "android";
  } else if (isIOS) {
    return "iOS";
  } else {
    return "PC";
  }
}

/**
 * 格式化时间戳
 * @param timestamp 时间戳
 * @param format 格式
 */
export function formatTs(timestamp, format = "YYYY-MM-DD HH:mm:ss") {
  if (!timestamp) return "--";
  return moment(timestamp).format(format);
}

/**
 * @param timestamp 格式化时间戳到日期
 */
export function formateDate(timestamp) {
  return moment(timestamp).format("YYYY-MM-DD");
}

/**
 * @param timestamp 报装进度页格式化时间戳
 */
export function formateDatePile(timestamp) {
  return moment(timestamp).format("YYYY/MM/DD HH:mm:ss");
}

/**
 * @param timestamp 格式化时间为上下午时间 例：上午8点
 */
export function formateHourTime(timestamp) {
  let mydate = new Date(timestamp);

  let hour = mydate.getHours();
  let now = "";
  if (hour <= 12) {
    now = "上午";
  } else {
    hour -= 12;
    now = "下午";
  }
  return now + hour + "点";
}

/**
 * @param timestamp 格式化时间为日期 今年：MM-DD 不是今年：YYYY-MM-DD
 */

export const formateDateIsNowYear = timestamp => {
  if (moment(timestamp).format("YYYY") === moment(new Date()).format("YYYY")) {
    return moment(timestamp).format("MM-DD");
  }
  return moment(timestamp).format("YYYY-MM-DD");
};

/**
 * @param timestamp 格式化时间戳到星期
 */
export function getDateWeek(timestamp) {
  const finalDay = new Date(timestamp);
  let Y: any = finalDay.getFullYear();
  let M: any = finalDay.getMonth() + 1;
  let D: any = finalDay.getDate();
  let W: any = finalDay.getDay();

  let b = "";
  switch (W) {
    case 0:
      b = "日";
      break;
    case 1:
      b = "一";
      break;
    case 2:
      b = "二";
      break;
    case 3:
      b = "三";
      break;
    case 4:
      b = "四";
      break;
    case 5:
      b = "五";
      break;
    default:
      b = "六";
  }
  if (M.toString().length == 1) {
    M = "0" + M;
  }
  if (D.toString().length == 1) {
    D = "0" + D;
  }
  const timeData = Y + "/" + M + "/" + D + " " + "周" + b;
  return timeData;
}

/**
 * 封装拼接url参数以便处理合理处理null和undefined值的问题
 * @param path
 * @param params
 */
export function generateUrlWithParam(path, params) {
  let paramsStr = "";
  const kvs: string[] = [];
  for (const key in params) {
    if (params[key]) {
      kvs.push(`${key}=${params[key]}`);
    }
  }
  paramsStr = kvs.join("&");
  return `${path}?${paramsStr}`;
}

/**
 * 返回当前页面的环境，依赖于当前域名
 */
export function getClientEnv() {
  let env = "test";
  if (window.location.href.indexOf("static.deploy-test.xiaopeng.com") !== -1) {
    env = "deploy";
  } else if (window.location.href.indexOf("static.xiaopeng.com") !== -1) {
    env = "product";
  }
  return env;
}

export function getLogEnv() {
  return {
    product: "production",
    dev: "test",
    test: "test",
    deploy: "pre"
  }[getClientEnv()];
}

/**
 * 埋点
 */
export function reportUserBehavior(
  // N002（充电业务4G家充桩）
  // N002001（4G家充桩）
  // appId:N003（充电业务失败指导页面）
  // so:N003001（失败指导页面）
  { appid = "N002", so = "N002001", mcode = "", pa = "", ch = "", ut },
  type = "event"
) {
  console.log(
    "页面埋点：appid:" + appid + "so:" + so + "mcode:" + mcode + "pa:" + pa
  );
  const report = new Report(
    {
      appid,
      so,
      mcode,
      pa,
      ch,
      ut
    },
    {
      env: getLogEnv()
    }
  );
  report.send({ type });
}

/**
 * 选择的vin码缓存
 */
export const VinCache = {
  key: "selected-vin",
  getCache() {
    const data = window.localStorage.getItem(this.key);
    return data;
  },
  refreshCache(val) {
    window.localStorage.setItem(this.key, val);
  }
};
// 关闭h5在App的分享按钮，iOS默认不可以分享，安卓默认可以分享
export function disableShare() {
  XPMotorApi.setOnActionButtonShowingHandler(() => {
    return { data: { share: false } };
  });
}
// 关闭浏览器
export function closeWindow() {
  if (isWXApp) {
    console.log("isWXApp-closeWindow");
    wxInit().then(wx => wx.miniProgram.navigateBack());
  } else if (isMyApp) {
    console.log("isMyApp-closeWindow");
    myInit().then(my => my.miniProgram.navigateBack());
  } else {
    XPMotorApi.getSdk().callHandler("closeWindow");
  }
}
// 回调数据给上一层页面
export function callbackData(data) {
  XPMotorApi.getSdk().callHandler("setResult", data);
}

/**
 * 监听webview关闭事件
 */
export function onWebviewClose(callback) {
  bridge.registerHandler("onClose", function(data, responseCallback) {
    if (typeof callback === "function") {
      callback();
    }
    responseCallback({}); // 回调给原生
  });
}

export function debounce<T>(fn: Function, delay = 200) {
  console.log("debounce");

  let lastFn: any;
  return function(this: T, ...args) {
    if (lastFn) {
      clearTimeout(lastFn);
    }
    lastFn = setTimeout(() => {
      lastFn = null;
      fn.call(this, ...args);
    }, delay);
  };
}
// 异步加载脚本
export function loadScript(scriptUrl: string, id: string): Promise<any> {
  if (!id) throw new Error("id is needed");
  if (!scriptUrl) throw new Error("scriptUrl is needed, please");

  const pro = new Promise((resolve: Function, reject: Function) => {
    // 避免缓存
    const $oldScript = document.getElementById("#" + id);
    if ($oldScript) {
      resolve();
      return;
    }
    const $script = document.createElement("script");
    $script.id = id;
    $script.type = "text/javascript";
    $script.onload = () => {
      resolve();
    };
    $script.onerror = err => {
      reject(err);
    };
    $script.src = scriptUrl;
    document.head.appendChild($script);
  });
  return pro;
}
// 设置导航投隐藏 慎用
export function transparentHeader(): Promise<any> {
  return XPMotorApi.getSdk().callHandler("modifyNavBarAlpha", { alpha: 0 });
}
// 调用原生定位方法
export function requestLocation(): Promise<any> {
  return XPMotorApi.getSdk().callHandler("requestLocation", {});
}
// 原生新开webview
export function webviewOpen(url, data?) {
  XPMotorApi.getSdk().callHandler("openUrl", {
    url,
    data
  });
}
// jsbridge的方法不是很好用，摘取自判断ua的方式来判断app
export function isInApp() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf("xiaopeng") !== -1;
}

//除法函数，用来得到精确的除法结果
//说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
//调用：accDiv(arg1,arg2)
//返回值：arg1除以arg2的精确结果
export function accDiv(arg1, arg2) {
  let t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = arg1.toString().split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  try {
    t2 = arg2.toString().split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  r1 = Number(arg1.toString().replace(".", ""));
  r2 = Number(arg2.toString().replace(".", ""));
  return (r1 / r2) * Math.pow(10, t2 - t1);
}
//乘法函数，用来得到精确的乘法结果
//说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
//调用：accMul(arg1,arg2)
//返回值：arg1乘以arg2的精确结果
export function accMul(arg1, arg2) {
  let m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
}
//加法函数，用来得到精确的加法结果
//说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
//调用：accAdd(arg1,arg2)
//返回值：arg1加上arg2的精确结果
export function accAdd(arg1, arg2) {
  let r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
}
//减法函数
export function accSub(arg1, arg2) {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  //动态控制精度长度
  n = r1 >= r2 ? r1 : r2;
  return ((arg2 * m - arg1 * m) / m).toFixed(n);
}

export function gotoMapNav(
  latitude?: number,
  longitude?: number,
  label?: string
) {
  XPMotorApi.getSdk().callHandler("navigate", {
    // 地址
    label: label,
    latitude: latitude,
    longitude: longitude
  });
}

export function sendToMyCar(
  latitude?: number,
  longitude?: number,
  name?: string,
  label?: string
) {
  XPMotorApi.getSdk().callHandler("sendAddress", {
    // 地点名
    userName: name,
    // 地址
    label: label,
    latitude: latitude,
    longitude: longitude
  });
}

// 版本位数不同一律为小于 -1：小于 0： 等于 1：大于
export function versionCompare(myVersion, targetVersion) {
  const myVersionArr = myVersion.split(".");
  const targetVersionArr = targetVersion.split(".");
  if (myVersionArr.length !== targetVersionArr.length) {
    return -1;
  }
  if (myVersion === targetVersion) {
    return 0;
  }
  let i = 0;
  while (i < targetVersionArr.length) {
    if (Number(myVersionArr[i]) > Number(targetVersionArr[i])) {
      return 1;
    }
    if (Number(myVersionArr[i]) < Number(targetVersionArr[i])) {
      return -1;
    }
    i++;
  }
  return -1;
}

// 根据版本号和页面环境隐藏内容
export function isNowVersionUpOrMatch(targetVersion) {
  if (!isXPApp) {
    return 1;
  }

  const ua = window.navigator.userAgent.toLowerCase();
  const REGEX = /^.*[com.tentcoo.XiaoPengQiCheEnterprise|com.xiaopeng.XiaoPengQiChe|com.xiaopeng.mycarinfo]\/([\d|.]*)/;
  const regResult = REGEX.exec(ua);
  if (regResult && regResult.length) {
    const curVersion = regResult[1].trim();
    return versionCompare(curVersion, targetVersion);
  }
  console.error("获取不到版本号");
  return -1;
}

/**
 * [通过参数名获取url中的参数值]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 * @param  {[string]} queryName [参数名]
 * @return {[string]}           [参数值]
 */
export function getUrlValue(queryName) {
  let reg = new RegExp("(^|&)" + queryName + "=([^&]*)(&|$)", "i");
  const query = window.location.search; // '?s=1&f=7'
  console.log("获取链接参数query");

  console.log(window.location);
  let r = query.substr(1).match(reg);
  console.log(r);
  if (r != null) {
    return decodeURI(r[2]);
  } else {
    return null;
  }
}

export function getUrlValueFromUrl(url: string, queryName: string) {
  const paramsString = url.split("?")[1] || "";
  const items = paramsString.split("&") || "";
  var params = {};
  if (items) {
    items.forEach(item => {
      const arr = item.split("=");
      const key = arr[0];
      const value = arr[1];
      params[key] = value;
    });
  }
  return params[queryName];
}

/**
 * 导航栏隐藏
 * 注意: 针对鸿蒙处理，一级页面设置了hide之后，二级页面要主动调用show，否则会导致二级页面导航栏未展示而样式错乱
 */
export function navHide(darkMode?: boolean) {
  if (isInApp()) {
    if (getPlatform() === "iOS") {
      bridge.callHandler("modifyNavBarAlpha", { alpha: 0 });
    } else {
      bridge.callHandler("setFullScreen", {
        fullScreen: true,
        darkMode: !!darkMode
      });
    }
  }
}

/**
 * 导航栏恢复
 */
export function navShow() {
  if (isInApp()) {
    if (getPlatform() === "iOS") {
      bridge.callHandler("modifyNavBarAlpha", { alpha: 1 });
    } else {
      bridge.callHandler("setFullScreen", {
        fullScreen: false,
        darkMode: false
      });
    }
  }
}

/**
 * [isXPApp]如果页面回退
 */

export function pageShow(callback?) {
  if (isInApp()) {
    window.onpageshow = function(event) {
      if (event.persisted && typeof callback === "function") {
        callback();
      }
    };

    bridge.registerHandler("onResult", function() {
      if (typeof callback === "function") {
        callback();
      }
    });
  }
}

export interface ShareType {
  shareTitle: string;
  shareDesc: string;
  sharePicUrlAccess: string;
  style?: number;
}
/**
 * APP、wx、小程序、骁龙、浏览器内的分享功能处理
 * ---
 * @param shareParam
 * @param shareParam.shareTitle - 分享标题
 * @param shareParam.shareDesc - 分享详情文本
 * @param shareParam.sharePicUrlAccess - 分享icon
 * @param shareUrl -分享url
 * @param posterImageBase64 -如果传该参数，APP则会启用分享海报, 分享的海报图片 base64 格式 需要移除头（比如：function已经处理该头 --->【/^data:image\/(jpeg|png|jpg);base64,/】 如果不一致，需要自己处理 ）
 */

export function simpleShare(
  { shareTitle, shareDesc, sharePicUrlAccess, style }: ShareType,
  shareUrl: string,
  posterImageBase64?: string
) {
  console.log("simpleShare", isInApp());

  if (isInApp()) {
    console.log("inAPP");

    if (posterImageBase64) {
      bridge.callHandler("sharePanel", {
        style: style || 4, // 海报专用分享面板
        addExtInfo: false, // 是否添加二维码等补充
        addUserInfo: false, // 是否添加用户信息
        addQrCode: false,
        data: {
          shareType: 2, // 虽然已经明确是海报分享，还是需要设置分享数据类型为图像
          title: shareTitle,
          content: shareDesc,
          postImage: posterImageBase64.replace(
            /^data:image\/(jpeg|png|jpg);base64,/,
            ""
          )
        }
      });
    } else {
      console.log("notinAPP");
      bridge
        .callHandler("sharePanel", {
          style: 0,
          data: {
            title: shareTitle,
            content: shareDesc,
            url: encodeURIComponent(shareUrl),
            thumImageUrl: sharePicUrlAccess || "",
            shareType: 3
          }
        })
        .catch(console.error);
    }
  }
}

export function imgToBase64(url: string, ratio = 1) {
  return new Promise<any>((resolve, reject) => {
    if (url) {
      let canvas = document.createElement("canvas") as any;
      const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      img.onload = function() {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        let dataURL = canvas.toDataURL("image/jpeg", ratio);
        resolve(dataURL);
        canvas = null;
      };
    } else {
      resolve("");
    }
  });
}

//
/**
 * 分享微信小程序
 * ---
 * @param shareMainTitle - 分享标题
 * @param shareSubTitle - 分享副标题
 * @param shareImgUrl - 分享图片
 * @param sharePath - 分享路径 默认当前页面
 *
 * */
export async function shareMiniProgramToWX({
  shareMainTitle,
  shareSubTitle,
  shareImgUrl,
  sharePath = location.href
}) {
  try {
    const imgBase64 = await imgToBase64(shareImgUrl, 0.5);
    const thumb = imgBase64.split(",")[1] || "";
    const thumbSizeKb = atob(thumb).length / 1024;

    let miniprogramType = 2; // 正式版:0，测试版:1，体验版:2
    if (getClientEnv() === "product") {
      miniprogramType = 0;
    }
    const callBridge: any = bridge.callHandler;
    callBridge.call(bridge, "shareMiniProgram", {
      webpageUrl: sharePath,
      miniprogramType,
      userName: "gh_bcdeac2bff9d",
      path: sharePath,
      title: shareMainTitle || "",
      desc: shareSubTitle || "",
      thumb: thumbSizeKb && thumbSizeKb <= 128 ? thumb : "" // base64, 小于128k, 不需要base64类型说明头，只需要传原始图片数据
    });
  } catch (error) {
    console.log("shareMiniProgram error-->", error);
  }
}
function half(number) {
  return number / 2;
}

const getCarString = (carList: string[]) => {
  let result = "";
  if (carList.length > 0) {
    carList.map((item, index) => {
      if (index === 0) {
        result = result + item;
      } else {
        result = result + `/${item}`;
      }
    });
  }
  return result;
};

/**
 * 生成海报
 * -
 * @param param
 * @param param.posterUrl // 海报背景图
 * @param imageType // 图片格式 如 【jpg/jpeg/png】
 * @param detail // 充电估算信息
 * @returns
 */
export function generatePoster(
  {
    bottomUrl,
    posterUrl,
    detail: {
      totalDistance,
      chargeAmt,
      chargeFee,
      chgSaveThanOilFee,
      carbonDeduction,
      treeNum
    }
  },
  imageType = "png"
): Promise<string> {
  console.log("generatePoster");

  return new Promise((resolve, reject) => {
    console.log("devicePixelRatio");
    const canvas = document.createElement("canvas");
    const ratio = (window.devicePixelRatio || 1) + 1;
    canvas.width = 375 * ratio;
    canvas.height = 812 * ratio;

    let store: HTMLImageElement[] = [];
    const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
    ctx.scale(ratio, ratio);

    // 首先清空画布
    ctx.clearRect(0, 0, 375, 812);
    ctx.save();

    function checkStore(HTMLImageElement) {
      store = store.filter(item => item !== HTMLImageElement);
      console.log("HTMLImageElement", HTMLImageElement);
      console.log("store", store);
      console.log("store111", store.length);

      if (store.length === 0) {
        resolve(canvas.toDataURL(`image/${imageType}`, 1));
      }
    }

    // 单位左边与数字的距离
    const unitLeft = 5;

    const bgImage = new Image();
    bgImage.crossOrigin = "anonymous";
    bgImage.src = posterUrl;
    bgImage.onerror = reject;
    console.log("准备  bgImage.onload");

    bgImage.onload = () => {
      console.log("bgImage.onload");
      ctx.drawImage(bgImage, 0, 0, 375, 812);

      // let i = ctx.measureText('').width

      // 我的充电估算
      ctx.font = `normal 600 ${26}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "center";
      ctx.fillText("我的充电估算", half(375), 130);

      // 快速估算出行距离与充电费用
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "center";
      ctx.fillText("快速估算出行距离与充电费用", half(375), 160);

      {
        /** 每年出行距离 */
      }
      // 数字
      ctx.font = `normal 500 ${30}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText(totalDistance, 72, 262);

      // 公里
      const totalDistanceLength = ctx.measureText(totalDistance).width;
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "rgba(0, 0, 0, 0.6)";
      ctx.textAlign = "left";
      ctx.fillText("公里", 72 + unitLeft + totalDistanceLength, 260);

      // 每年出行距离
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText("每年出行距离", 72, 285);

      {
        /** 年度充电度数 */
      }

      // 数字
      ctx.font = `normal 500 ${30}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText(chargeAmt, 225, 262);

      // 度
      const chargeAmtLength = ctx.measureText(chargeAmt).width;
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "rgba(0, 0, 0, 0.6)";
      ctx.textAlign = "left";
      ctx.fillText("度", 225 + unitLeft + chargeAmtLength, 260);
      // 年度充电度数
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText("年度充电度数", 225, 285);

      {
        /** 年度充电费用 */
      }
      // 数字
      ctx.font = `normal 500 ${30}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText(chargeFee, 70, 348);
      // 元
      const chargeFeeLength = ctx.measureText(chargeFee).width;
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "rgba(0, 0, 0, 0.6)";
      ctx.textAlign = "left";
      ctx.fillText("元", 70 + unitLeft + chargeFeeLength, 346);

      // 年度充电费用
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText("年度充电费用", 70, 370);

      {
        /** 对比燃油节省 */
      }
      // 数字
      ctx.font = `normal 500 ${30}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText(chgSaveThanOilFee, 225, 348);
      // 元
      const chgSaveThanOilFeeLength = ctx.measureText(chgSaveThanOilFee).width;
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "rgba(0, 0, 0, 0.6)";
      ctx.textAlign = "left";
      ctx.fillText("元", 225 + unitLeft + chgSaveThanOilFeeLength, 346);
      // 对比燃油节省
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText("对比燃油节省", 225, 370);

      // 省钱之余，我还
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "center";
      ctx.fillText("省钱之余，我还", half(375), 440);
      // 对
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText("对", 90, 470);
      // 地球生态环保
      ctx.font = `normal 500 ${17}px 'Futura'`;
      ctx.fillStyle = "#6DA23A";
      ctx.textAlign = "left";
      ctx.fillText("地球生态环保", 107, 471);
      // 做出了贡献！
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText("做出了贡献！", 212, 470);

      // 动态匹配长度
      let bottomConnentLength = 0;
      ctx.font = `normal 400 ${14}px 'Futura'`;
      bottomConnentLength =
        bottomConnentLength +
        ctx.measureText("达成碳减排  kg，相当于植树  棵").width;
      ctx.font = `normal 500 ${21}px 'Futura'`;
      bottomConnentLength =
        bottomConnentLength + ctx.measureText(carbonDeduction).width;
      bottomConnentLength =
        bottomConnentLength + ctx.measureText(treeNum).width;
      let renderLeft = half(375 - bottomConnentLength);

      // 达成碳减排
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText("达成碳减排 ", renderLeft, 500);
      renderLeft = renderLeft + ctx.measureText("达成碳减排 ").width;

      // 数据
      ctx.font = `normal 500 ${21}px 'PingFang SC'`;
      ctx.fillStyle = "#6DA23A";
      ctx.textAlign = "left";
      ctx.fillText(carbonDeduction, renderLeft, 502);
      renderLeft = renderLeft + ctx.measureText(carbonDeduction).width;

      // kg
      ctx.font = `normal 400 ${14}px 'PingFang SC'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText(" kg", renderLeft, 500);
      renderLeft = renderLeft + ctx.measureText(" kg").width;

      // ，相当于植树
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText("，相当于植树 ", renderLeft, 500);
      renderLeft = renderLeft + ctx.measureText("，相当于植树 ").width;

      // 数据
      ctx.font = `normal 500 ${21}px 'PingFang SC'`;
      ctx.fillStyle = "#6DA23A";
      ctx.textAlign = "left";
      ctx.fillText(treeNum, renderLeft, 502);
      renderLeft = renderLeft + ctx.measureText(treeNum).width;

      // 棵
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText(" 棵", renderLeft, 500);

      // 底部二维码&葵花码
      const bottomImage = new Image();
      store.push(bottomImage);
      bottomImage.crossOrigin = "anonymous";
      bottomImage.src = bottomUrl;
      bottomImage.onerror = reject;
      bottomImage.onload = () => {
        console.log("bottomUrl", bottomImage);
        ctx.drawImage(bottomImage, 30, 713, 315, 66);
        ctx.restore();
        checkStore(bottomImage);
      };
    };
  });
}

function drawRoundedRect(
  ctx,
  x,
  y,
  width,
  height,
  r,
  fill = false,
  stroke = false
) {
  ctx.save();
  ctx.beginPath();

  // draw top and top right corner
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + width, y, x + width, y + r, r);

  // draw right side and bottom right corner
  ctx.arcTo(x + width, y + height, x + width - r, y + height, r);

  // draw bottom and bottom left corner
  ctx.arcTo(x, y + height, x, y + height - r, r);

  // draw left and top left corner
  ctx.arcTo(x, y, x + r, y, r);

  if (fill) {
    ctx.fill();
  }

  if (stroke) {
    ctx.stroke();
  }

  ctx.restore();
}
/**
 * 对数字或者数字字符串添加千分符
 * @param numStr
 * @returns
 */
export const addThousandthSign = (numStr?: string | number) => {
  if (!numStr) return "--";
  const regForm = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;
  return numStr.toString().replace(regForm, "$1,");
};

function loadJs(src) {
  return new Promise((resolve, reject) => {
    const ref = document.getElementsByTagName("script")[0];
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    (ref.parentNode as any).insertBefore(script, ref);
    script.onload = resolve;
    script.onerror = reject;
  });
}
function load(url: string) {
  return loadJs(url).catch(() => loadJs(url));
}
export function wxInit(): Promise<any> {
  // 避免重复加载
  // @ts-ignore
  if (window.wx && typeof window.wx.config === "function") {
    console.log("wx获取了缓存的SDK");
    // @ts-ignore
    return Promise.resolve(window.wx);
  }

  // 加载 jssdk 后初始化
  return (
    load("//res.wx.qq.com/open/js/jweixin-1.6.0.js#wechat_redirect")
      // @ts-ignore
      .then(() => Promise.resolve(window.wx))
  );
}
// 支付宝小程序
export function myInit(): Promise<any> {
  // 避免重复加载
  // @ts-ignore
  if (window.my && window.my.navigateTo) {
    // @ts-ignore
    return Promise.resolve(window.my);
  }

  // 加载 jssdk 后初始化
  return (
    load("//appx/web-view.min.js")
      // @ts-ignore
      .then(() => Promise.resolve(window.my))
  );
}

export const throttle = (fn, delay) => {
  let timer;
  return (...arg) => {
    if (timer) return;
    timer = setTimeout(() => {
      fn(...arg);
      clearTimeout(timer);
      timer = undefined;
    }, delay);
  };
};

export const flatten = arr => {
  return arr.reduce((res, next) => {
    return res.concat(Array.isArray(next) ? flatten(next) : next);
  }, []);
};

export const uuidGenerator = (len?, radix?) => {
  const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
    ""
  );
  let uuid: any[] = [],
    i;
  radix = radix || chars.length;
  len = len || 16;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    // rfc4122, version 4 form
    let r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join("");
};

// 获取设备ID
export const getDeviceId = (cookieName: string) => {
  if (Cookie.get(cookieName)) {
    return Cookie.get(cookieName);
  } else {
    const deviceId = uuidGenerator();
    Cookie.set(cookieName, deviceId, { expires: 7, path: "/" });
    return deviceId;
  }
};

export const getChannel = () => {
  const UA = navigator.userAgent || "";
  const isDragon = /XdragonWebView/i.test(UA); // 骁龙app
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const isWX = /micromessenger/i.test(UA); // 微信
  const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
  const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序
  if (isXPApp) {
    return "xpApp";
  } else if (isMyApp || isWXApp) {
    return isMyApp ? "alipay" : "weapp";
  } else if (isDragon) {
    return "dragon";
  } else {
    return "browser";
  }
};

// 获取域名
export const getDomain = () => {
  let apiDomain = "";
  if (window.location.href.indexOf("static.deploy-test.xiaopeng.com") !== -1) {
    apiDomain = "https://chargegateway.deploy-test.xiaopeng.com";
  } else if (window.location.href.indexOf("static.xiaopeng.com") !== -1) {
    apiDomain = "https://chargegateway.xiaopeng.com";
  } else {
    apiDomain = "http://chargegateway.test.xiaopeng.local";
  }
  return apiDomain;
};

/**
 * 由于当前充电H5的路由是hash模式，所有的query参数都在hash中，所以需要从hash中获取参数，否则在小程序端会获取不到
 */
export const getParamsFromHash = (key: string) => {
  const params = {};
  const hash = window.location.hash;
  const queryString = hash.split("?")[1];
  if (queryString) {
    queryString.split("&").forEach(item => {
      const [k, value] = item.split("=");
      params[k] = value;
    });
  }
  if (!params[key] || ["undefined", "null"].includes(params[key])) {
    return "";
  }
  return decodeURIComponent(params[key]);
};

export const getParamsFromHref = (key: string) => {
  const params = {};
  const href = window.location.href;
  const queryString = href.split("?")[1];
  if (queryString) {
    queryString.split("&").forEach(item => {
      const [k, value] = item.split("=");
      params[k] = value;
    });
  }
  if (!params[key] || ["undefined", "null"].includes(params[key])) {
    return "";
  }
  // 避免路由hash模式时，获取到的query参数带有#/
  if (params[key].indexOf("#/") !== -1) {
    return decodeURIComponent(params[key]).replace("#/", "");
  }
  return decodeURIComponent(params[key]);
};

/**
 * 判断一个元素是否在可视窗口内
 * @param element
 * @returns
 */
export function isInViewPort(element, navBarHeight = 0) {
  const viewWidth = window.innerWidth || document.documentElement.clientWidth;
  const viewHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const { top, right, bottom, left } = element.getBoundingClientRect();

  if (navBarHeight > 0) {
    return (
      top >= navBarHeight &&
      left >= 0 &&
      right <= viewWidth &&
      bottom <= viewHeight
    );
  }

  return top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight;
}

/**
 * H5需要在APP\小程序\普通浏览器中都可以打开，特殊考虑小程序页面跳转需要使用小程序的跳转方式，封装一个H5页面跳转方法
 * @param url
 * @param appId 业务方H5的用户中心appid
 * @param params
 */
export function goToPage(url: string, appId = "", params = {}) {
  if (!url) return;

  if (isXPApp) {
    setTimeout(() => {
      window.location.href = transformToQueryUrl(url, params);
    }, 300);
  } else if (isWXApp) {
    wxInit().then(wx =>
      wx.miniProgram.navigateTo({
        url: `/pages/webpage/index?pageUrl=${encodeURIComponent(
          transformToQueryUrl(url, params)
        )}&appId=${appId}`
      })
    );
  } else if (isMyApp) {
    myInit().then(my =>
      my.navigateTo({
        url: `/pages/webpage/index?pageUrl=${encodeURIComponent(
          transformToQueryUrl(url, params)
        )}&appId=${appId}`
      })
    );
  } else {
    setTimeout(() => {
      window.location.href = transformToQueryUrl(url, params);
    }, 300);
  }
}

// 浏览器的hash路由补充为完整的url
function completedUrlOfHash(hash: string) {
  const { pathname, origin } = location;
  return `${origin}${pathname}#${hash}`;
}

/**
 * H5需要在APP\小程序\普通浏览器中都可以打开，特殊考虑小程序页面跳转需要使用小程序的跳转方式，封装一个H5页面跳转方法
 * @param url 完整的前端http 的url
 * @param appId 业务方H5的用户中心appid
 * @param params
 * @param hash 前端hash路由
 * @description v2版本在小鹏app内容，新开webview的方式跳转页面
 */
export function goToPageV2({
  url,
  appId = "",
  params,
  hash
}: {
  url?: string;
  appId?: string;
  params?: object;
  hash?: string;
}) {
  const targetUrl = url ? url : hash && completedUrlOfHash(hash);
  if (!targetUrl) return;
  if (isXPApp) {
    webviewOpen(transformToQueryUrl(targetUrl, params));
  } else if (isWXApp) {
    wxInit().then(wx =>
      wx.miniProgram.navigateTo({
        url: `/pages/webpage/index?pageUrl=${encodeURIComponent(
          transformToQueryUrl(targetUrl, params)
        )}&appId=${appId}`
      })
    );
  } else if (isMyApp) {
    myInit().then(my =>
      my.navigateTo({
        url: `/pages/webpage/index?pageUrl=${encodeURIComponent(
          transformToQueryUrl(targetUrl, params)
        )}&appId=${appId}`
      })
    );
  } else {
    setTimeout(() => {
      window.location.href = transformToQueryUrl(targetUrl, params);
    }, 300);
  }
}

/**
 * H5需要跳转APP/小程序原生页面
 * @param urlConfig
 */
export function goToNativePage(urlConfig: {
  mini: string;
  app: string;
  browser?: string;
}) {
  const env = isXPApp ? "app" : (isWXApp || isMyApp) ? "mini" : "browser";
  const url = urlConfig[env]
  if (!url) return;

  if (isXPApp) {
    setTimeout(() => {
      XPMotorApi.getSdk().callHandler("openUrl", { url });
    }, 300);
  } else if (isWXApp) {
    wxInit().then(wx => wx.miniProgram.navigateTo({ url }));
  } else if (isMyApp) {
    myInit().then(my => my.navigateTo({ url }));
  } else {
    window.location.href = url;
  }
}

/**
 * H5需要在APP\小程序\普通浏览器中都可以打开，特殊考虑小程序页面，封装一个back方法
 */
export function goBack() {
  const router = window.history;

  if (isXPApp) {
    XPMotorApi.getSdk().callHandler("closeWindow");
  } else if (isWXApp) {
    wxInit().then(wx => {
      wx.miniProgram.navigateBack();
      setTimeout(() => {
        wx.miniProgram.switchTab({
          url: `/pages/station-list/index`
        });
      }, 300);
    });
  } else if (isMyApp) {
    myInit().then(my => {
      my.navigateBack();
      setTimeout(() => {
        my.switchTab({
          url: `/pages/station-list/index`
        });
      }, 300);
    });
  } else {
    router.back();
  }
}

/**
 * H5需要在APP\小程序\普通浏览器中都可以打开，特殊考虑小程序页面，封装一个back方法
 */
export function goBackV2() {
  const router = window.history;

  if (isXPApp) {
    XPMotorApi.getSdk().callHandler("goBack");
  } else if (isWXApp) {
    wxInit().then(wx => {
      wx.miniProgram.navigateBack();
      setTimeout(() => {
        wx.miniProgram.switchTab({
          url: `/pages/station-list/index`
        });
      }, 300);
    });
  } else if (isMyApp) {
    myInit().then(my => {
      my.navigateBack();
      setTimeout(() => {
        my.switchTab({
          url: `/pages/station-list/index`
        });
      }, 300);
    });
  } else {
    router.back();
  }
}

/**
 * 兼容两端系统返回问题
 */
export function goBackCompatible() {
  const router = window.history;
  if (isXPApp) {
    XPMotorApi.getSdk().callHandler("goBack");
  } else if (isWXApp) {
    wxInit().then(wx => {
      wx.miniProgram.navigateBack();
      setTimeout(() => {
        wx.miniProgram.switchTab({
          url: `/pages/station-list/index`
        });
      }, 300);
    });
  } else if (isMyApp) {
    myInit().then(my => {
      my.navigateBack();
      setTimeout(() => {
        my.switchTab({
          url: `/pages/station-list/index`
        });
      }, 300);
    });
  } else {
    router.back();
  }
}

export function downloadImage(src, imgName) {
  return new Promise<any>((resolve, reject) => {
    let image = new Image();
    image.src = src;
    image.setAttribute("crossOrigin", "anonymous");
    image.onerror = function() {
      reject("保存失败");
    };
    image.onload = function() {
      let c = document.createElement("canvas");
      c.width = image.width;
      c.height = image.height;
      c.getContext("2d")?.drawImage(image, 0, 0, image.width, image.height);
      let a = document.createElement("a");
      a.download = imgName;
      a.href = c.toDataURL("image/png");
      a.click();
      resolve("");
    };
  });
}

export const hidePhoneNum = (phone, holder = "*") => {
  phone = String(phone);
  let phoneArr = phone.split("");
  console.log(phoneArr);
  let length = phoneArr.length;
  if (!(length % 2)) {
    let mid = length / 2 - 1;
    mid >= 0 && (phoneArr[mid] = holder);
    mid - 1 > 0 && (phoneArr[mid - 1] = holder);
    mid + 1 > 0 && (phoneArr[mid + 1] = holder);
    mid + 2 < length && (phoneArr[mid + 2] = holder);
  } else {
    let mid = Math.ceil(length / 2) - 1;
    mid > 0 && (phoneArr[mid] = holder);
    mid - 1 > 0 && (phoneArr[mid - 1] = holder);
    mid - 2 > 0 && (phoneArr[mid - 2] = holder);
    mid + 1 < length && (phoneArr[mid + 1] = holder);
  }
  return phoneArr.join("");
};

export const priceFormat = price => {
  let stringPrice = Number(price / 100).toFixed(2);
  let priceArr = stringPrice.split(".");
  if (priceArr[1] === "00") {
    return priceArr[0];
  } else if (priceArr[1]?.[1] === "0") {
    return priceArr[0] + "." + priceArr[1][0];
  } else {
    return stringPrice;
  }
};

// 控制数字小数点后位数， 末尾的0不显示
export const formatNumber = (num: number, precision: number) => {
  if (num === 0) {
    return "0";
  }
  if (!num) {
    return "";
  }
  return num.toFixed(precision).replace(/(\.0+|0+)$/, "");
};

/**
 * 定义H5在小程序内的分享信息，包含微信/支付宝/高德小程序
 * @param data shareTitle: string, shareIcon: string, shareUrl: string
 */
export const defineShareInfoInMiniProgram = (data: {
  shareTitle?: string;
  shareIcon?: string;
  shareUrl?: string;
}) => {
  if (isWXApp) {
    wxInit().then(wx =>
      wx.miniProgram.postMessage({
        data
      })
    );
  } else if (isMyApp) {
    myInit().then(my =>
      my.postMessage({
        data
      })
    );
  }
};

// 判断字节长度
export const isByteLengthInRange = (
  str: string,
  min: number,
  max: number
): boolean => {
  const encoder = new TextEncoder();
  const byteLength = encoder.encode(str).length;
  return byteLength > min && byteLength <= max;
};

// 家充购买页地址
export const BuyHomeChargeUrl =
  "https://mall.xiaopeng.com/product/1530137912979308545?entry=300060";

/**
 * 昼夜模式样式处理
 */
export const themeInit = () => {
  const versionMark = isNowVersionUpOrMatch("5.1.0");
  if (versionMark > -1) {
    bridge
      .callHandler("getThemeMode")
      .then(res => {
        // H5暂未做暗夜模式，但APP webview底色在暗夜模式下是黑色，这里给body兜底白色背景
        if (res.data?.mode === "dark") {
          document.body.style.backgroundColor = "#fff";
        }
      })
      .catch(() => {});

    bridge.registerHandler("onThemeModeChange", function(
      data,
      responseCallback
    ) {
      if (data?.mode === "dark") {
        document.body.style.backgroundColor = "#fff";
      } else {
        document.body.style.backgroundColor = "";
      }
    });
  }
};

/**
 * 上拉加载更多
 */
export const onScrollLoadMore = (props: {
  scrollDomRef: React.RefObject<HTMLDivElement>;
  list: any[];
  pageNo: number;
  pageSize: number;
  setPageNo: (pageNo: number) => void;
  callback: () => void;
}) => {
  const {
    scrollDomRef,
    list,
    pageNo,
    pageSize,
    setPageNo = () => {},
    callback = () => {}
  } = props;

  const dom: any = scrollDomRef.current;
  if (dom) {
    const isEnd = dom.scrollTop >= dom.scrollHeight - dom.clientHeight;
    if (isEnd) {
      // 列表数据加载结束
      if (list.length < pageNo * pageSize) {
        return;
      }
      setPageNo(pageNo + 1);
      callback();
    }
  }
};

export const getAmapHost = () => {
  // if (window.location.origin.indexOf('http://localhost/'))
  if (process.env.NODE_ENV === "development") {
    return "/_AMapService";
  }
  return (
    (window as any)?._AMapSecurityConfig?.serviceHost ||
    window.location.origin + "/_AMapService"
  );
};

export const getAreaListByAdcode = ({ filter }) => {
  const params = {
    key: "6657470c50268b502426e5f406d1a444",
    subdistrict: 3,
    extensions: "base"
  } as any;
  filter && (params.keywords = filter);
  axios({
    url: `${getAmapHost()}/v3/config/district`,
    data: {},
    params,
    method: "GET"
  })
    .then((result: any) => {
      const { infocode, info, districts } = result.data;
      if (!["10000"].includes(infocode)) {
        console.log("服务器开小差:" + info);
        return;
      }
      let areaList =
        (districts && !!districts.length && districts[0].districts) ||
        ([] as TArea[]);
      let newAreaList = areaList.filter((item: TArea) => {
        return !["810000", "820000", "710000"].includes(item.adcode as string);
      });
      console.log("newAreaList", newAreaList);
    })
    .catch((err: any) => {
      console.log("err", err);
    });
};

export class AreaList {
  static task: Promise<any> | null = null;

  constructor() {
    this.fetchAreaList();
  }

  getDistrictCode = (location: any) => {
    return new Promise(res => {
      // 初始化逆地理编码
      const AMap = (window as any).AMap;
      var geocoder = new AMap.Geocoder({
        city: "全国", // 默认全国，可根据输入限制
        radius: 100 // 范围
      });

      if (!location?.lng || !location?.lat) {
        res(null);
        return;
      }

      // 根据经纬度获取详细地址信息
      geocoder.getAddress(location, function(status, result) {
        if (status === "complete" && result.regeocode) {
          const addressComponent = result?.regeocode?.addressComponent;
          if (!addressComponent) {
            res(null);
            return;
          }
          res(addressComponent);
          console.log("行政区划信息：", result);
        } else {
          res(null);
        }
      });
    }).catch(() => null);
  };

  getAreaList() {
    const params = {
      key: "6657470c50268b502426e5f406d1a444",
      subdistrict: 3,
      extensions: "base"
    } as any;
    return axios({
      url: `${getAmapHost()}/v3/config/district`,
      data: {},
      params,
      method: "GET"
    })
      .then((result: any) => {
        const { infocode, info, districts } = result.data;
        if (!["10000"].includes(infocode)) {
          console.log("服务器开小差:" + info);
          return null;
        }
        let areaList =
          (districts && !!districts.length && districts[0].districts) ||
          ([] as TArea[]);
        let newAreaList = areaList.filter((item: TArea) => {
          return !["810000", "820000", "710000"].includes(
            item.adcode as string
          );
        });
        console.log("newAreaList", newAreaList);
        return newAreaList;
      })
      .catch((err: any) => {
        // @ts-ignore
        Sentry.captureException(
          new Error(`行政编码选择错误-行政编码列表接口出错：${err}`)
        );
        // 重置获取接口task
        AreaList.task = null;
        return null;
      });
  }
  async fetchAreaList() {
    if (AreaList.task) {
      return AreaList.task;
    }

    AreaList.task = this.getAreaList();

    return AreaList.task;
  }

  async searchByAdCode(adcode: string, location) {
    console.log("adcode", adcode);
    const task = await this.fetchAreaList();
    if (!task) {
      // @ts-ignore
      Sentry.captureException(
        new Error(`行政编码选择错误-行政编码列表接口出错-return:${adcode}`)
      );
      return null;
    }

    const res = this.DFSSearch(task, adcode);
    if (Array.isArray(res) && res.length === 3) {
      // 处理直筒子市，用getDistrictCode 查具体信息
      const city = res[1];
      const district = res[2];
      if (city.code === district.code && location?.lng && location?.lat) {
        //  city.code = city.citycode
        const addressComponent: any = await this.getDistrictCode(location);
        if (addressComponent && addressComponent.township) {
          district.name = addressComponent.township;
          // district.code = addressComponent.towncode
        }
      }
      console.log("res", res);
      return res;
    }
    // @ts-ignore
    Sentry.captureException(
      new Error(`行政编码选择错误-adcode-${adcode}-res:${JSON.stringify(res)}`)
    );
    return null;
  }

  DFSSearch(tree: any, code: string, depth = [] as any[]) {
    if (depth.length === 3) {
      return depth;
    }
    if (!Array.isArray(tree)) {
      return null;
    }

    if (tree.length === 0) {
      return null;
    }

    for (let i = 0; i < tree.length; i++) {
      let node = tree[i];
      depth.push({
        name: node.name,
        code: node.adcode,
        citycode: typeof node.citycode === "string" ? node.citycode : ""
      });
      const hasDistricts =
        Array.isArray(node.districts) && node.districts.length > 0;
      if (node.adcode === code && !hasDistricts) {
        return depth;
      }
      if (hasDistricts) {
        const res = this.DFSSearch(node.districts, code, depth);
        if (res) {
          return depth;
        }
      }
      depth.pop();
    }
    return null;
  }
}

/**
 * 下载目标 URL 的文件
 * @param url - 文件的 URL
 * @param filename - 下载后的文件名
 */
export async function downloadFile(url: string, filename = "") {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch file from ${url}`);
    }

    const blob = await response.blob();
    const urlObject = URL.createObjectURL(blob);

    // 如果没有提供文件名，从 URL 中提取文件名
    if (!filename) {
      const urlParts = url.split("/");
      const name = urlParts[urlParts.length - 1];
      filename = name ? decodeURIComponent(name) : "";
    }

    const a = document.createElement("a");
    a.href = urlObject;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    // 清理
    document.body.removeChild(a);
    URL.revokeObjectURL(urlObject);
  } catch (error) {
    console.error("下载文件失败:", error);
  }
}

/**
 * 打开文件 兼容APP和小程序
 */
export const openDocument = (url: string) => {
  if (isXPApp) {
    window.location.href = url;
  } else if (isWXApp) {
    wxInit().then(wx =>
      wx.miniProgram.navigateTo({
        url: `/pages/open-document/index?url=${encodeURIComponent(url)}`
      })
    );
  } else if (isMyApp) {
    myInit().then(my =>
      my.navigateTo({
        url: `/pages/open-document/index?url=${encodeURIComponent(url)}`
      })
    );
  } else {
    window.location.href = url;
  }
};

/**
 * 获取高德定位promise
 */
export const getLocationGeoPro = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const AMap = (window as any).AMap;
      var mapObj = new AMap.Map("iCenter");
      mapObj.plugin("AMap.Geolocation", function() {
        console.log("mapObj", AMap);
        let geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 5000 // 超过10秒后停止定位，默认：无穷大
        });
        mapObj.addControl(geolocation);
        geolocation.getCurrentPosition();
        AMap.event.addListener(geolocation, "complete", result => {
          console.log("getCurrentPosition-complete", result);
          resolve({
            lng: result.position.lng,
            lat: result.position.lat,
            adcode: result.addressComponent.adcode
          });
        }); // 返回定位信息
        AMap.event.addListener(geolocation, "error", result => {
          console.error("高德定位失败:" + result.message);
          reject(result.message);
        }); // 返回定位出错信息
      });
    } catch (error) {
      console.error("getLocationGeoPro error", error);
      reject(error);
    }
  });
};
/**
 * 组合定位，如果在app内，使用app的定位，拿不到定位再使用高德的定位
 */
export const getLocation = () => {
  if (isXPApp) {
    return requestLocation().then((res: any) => {
      console.log("app定位", res);
      if (res.data.coords.longitude && res.data.coords.latitude) {
        return {
          lng: res.data.coords.longitude,
          lat: res.data.coords.latitude,
          adcode: res.data.adCode
        };
      } else {
        return getLocationGeoPro();
      }
    });
  } else {
    return getLocationGeoPro();
  }
};

/*
 *  预加载图片
 */

export const preloadImages = config => {
  config.forEach(item => {
    const img = new Image();
    img.src = item;
  });
};

/**
 *  是否是空对象
 */
export const isEmptyObj = (obj: object) => {
  return Object.keys(obj).length === 0;
};

/**
 * 复制文本到剪切板
 */
export const copyToClipBoard = (
  str: string,
  showToast: boolean = false,
  toastText: string = "已复制"
) => {
  const input = document.createElement("input");
  input.value = str;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);

  showToast &&
    Toast.show({
      text: toastText,
      duration: 800
    });
};

export const getPrizeText = (item: any) => {
  console.log("getPrizeText", item);
  if (!item) return "";
  const { prizeAttribute, prizeType, prizeName, prizeValue } = item;

  const storeCardText = `${prizeAttribute?.pqAmt}元储值卡`;
  const electricCardText = `${prizeAttribute?.pqAmt}度电卡`;
  const frequencyCard = `${prizeAttribute?.pqAmt}次电卡`;
  const serviceCard = `服务费${prizeAttribute?.discFactor}折电卡`;
  const discountCard = `${prizeAttribute?.discFactor}折电卡`;

  switch (prizeType) {
    case 1: {
      // 充电券
      if (prizeAttribute.couponType === 1) {
        return prizeAttribute.thresholdPrice &&
          prizeAttribute.thresholdPrice !== "0"
          ? `满${prizeAttribute.thresholdPrice}减${prizeAttribute.couponFee}元券`
          : `立减${prizeAttribute.couponFee}元券`;
      }
      if (prizeAttribute.couponType === 2) {
        return prizeAttribute.thresholdPrice &&
          prizeAttribute.thresholdPrice !== "0"
          ? `满${prizeAttribute.thresholdPrice}元${prizeAttribute.couponFee}折券`
          : `立享${prizeAttribute.couponFee}折券`;
      }
      break;
    }
    case 2: // 储值卡
      return storeCardText;
    case 3: // 电量卡
      return electricCardText;
    case 4: // 活动平台活动参与机会
      return `${prizeName}`;
    case 5: // 服务费折扣卡
      return serviceCard;
    case 6: // 充电券包
      return `${prizeAttribute.totalFee}元券包`;
    case 7: // 充电VIP卡
      return `${prizeAttribute.days}天VIP卡`;
    case 8: // 小鹏积分
      return `${prizeValue}积分`;
    case 9: // 整单折扣卡
      return discountCard;
    case 10: // 次数卡
      return frequencyCard;
    case 11: // 充电卡（除服务费折扣卡）,充电卡分类.04-次数卡, 05-整单折扣卡，06-电量卡，07-储值卡，08-服务费折扣卡
      if (prizeAttribute.pqType === "04") {
        return frequencyCard;
      }
      if (prizeAttribute.pqType === "05") {
        return discountCard;
      }
      if (prizeAttribute.pqType === "06") {
        return electricCardText;
      }
      if (prizeAttribute.pqType === "07") {
        return storeCardText;
      }
      if (prizeAttribute.pqType === "08") {
        return serviceCard;
      }
      break;
    case 12: // 渠道生活权益
      return `${prizeName}`;
    case 13: // 抽奖次数
      return `抽奖机会`;
    case 14: // 14-商城优惠券
      return `${prizeName}`;
    default:
      break;
  }
};

/**
 * 图片上传函数
 */
export const uploadImage = async (file: File): Promise<string> => {
  // 校验图片类型和大小
  const beforeUploadImgTypeLimit = (file: File): boolean => {
    const fileExtension = file.name
      .substring(file.name.lastIndexOf(".") + 1)
      .toLowerCase();

    if (!["png", "jpeg", "jpg", "bmp"].includes(fileExtension)) {
      throw new Error("暂不支持该文件格式");
    }

    const maxSize = 10240 * 1024; // 10MB
    if (file.size > maxSize) {
      throw new Error("图片大小不能超过10M");
    }

    return true;
  };

  // 获取OSS客户端
  const getOssClient = (file: File): Promise<any> => {
    return new Promise((resolve, reject) => {
      getToken({ pathType: 3, fileName: file.name })
        .then((result: any) => {
          const { code, msg, data } = result;

          if (![200, 0].includes(code)) {
            reject(new Error("服务器开小差:" + msg));
            return;
          }

          const ossData = data || {};
          const client = new OSS({
            accessKeyId: ossData.accessKeyId,
            accessKeySecret: ossData.accessKeySecret,
            stsToken: ossData.stsToken,
            region: ossData.region,
            bucket: ossData.bucket
          });

          const clientTemp = {
            domain: data.domain,
            pathPrefix: data.pathPrefix,
            useHttpForAccessLink: data.useHttpForAccessLink,
            fileName: data.fileName,
          };

          const ossClient = Object.assign(client, clientTemp);
          resolve(ossClient);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  };

  // OSS上传文件
  const ossUploadFile = async (file: File): Promise<string> => {
    const client = await getOssClient(file);
    const fileName = client.fileName;

    // 构建完整的文件URL
    const protocol = client.useHttpForAccessLink ? "https://" : "http://";
    const filePath =
      protocol + client.domain + "/" + client.pathPrefix + "/" + fileName;

    return filePath;
  };

  try {
    // 验证文件
    beforeUploadImgTypeLimit(file);

    // 上传文件并返回URL
    const imageUrl = await ossUploadFile(file);
    return imageUrl;
  } catch (error) {
    throw error;
  }
};

export function urlToBase64(url: string): Promise<string> {
  return new Promise((resolve, reject) => {
    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.blob();
      })
      .then(blob => {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (reader.result && typeof reader.result === "string") {
            resolve(reader.result);
          } else {
            reject(new Error("无法读取文件内容"));
          }
        }; // 成功时返回 Base64 数据
        reader.onerror = reject; // 读取失败时 reject
        reader.readAsDataURL(blob); // 将 Blob 转换为 Base64
      })
      .catch(reject); // fetch 失败时 reject
  });
}

/**
 * 获取高德经纬度翻译地址
 */
export const getLocationToAddress = ({ lng, lat }) => {
  return new Promise(resolve => {
    try {
      loadScript(
        "https://webapi.amap.com/maps?v=1.4.12&key=97005306e21be3a9a88ac7393a26f1ca",
        "par-web-script"
      ).then(() => {
        const AMap = (window as any).AMap;
        const map = new AMap.Map("", {});
        map.plugin("AMap.Geocoder", () => {
          const geocoder = new AMap.Geocoder({});
          geocoder.getAddress([lng, lat], function(status, result) {
            if (status === "complete" && result.info === "OK") {
              console.log("getLocationToAddress", result);
              resolve(result?.regeocode?.formattedAddress);
            } else {
              resolve("");
            }
          });
        });
      });
    } catch (error) {
      console.error("getLocationToAddress error", error);
    }
  });
};

// 总部默认定位信息
export const defaultPoint = {
  lng: 113.38477,
  lat: 23.15944,
  citycode: "020",
  cityName: "广州市"
};

/**
 * 格式化地址信息
 * @param locationData 位置数据
 * @param isUseDefault 是否使用默认位置
 * @returns Promise<{ lng: number, lat: number, address?: string, isUseDefault?: boolean }>
 */
const formatLocationResult = async (
  locationData: { lng: number; lat: number },
  isUseDefault: boolean = false
): Promise<{
  lng: number;
  lat: number;
  address?: string;
  isUseDefault?: boolean;
}> => {
  try {
    const address = await getLocationToAddress(locationData);
    return {
      ...locationData,
      address: address as string | undefined,
      isUseDefault
    };
  } catch (error) {
    console.error("地址解析失败:", error);
    return {
      ...locationData,
      address: isUseDefault
        ? defaultPoint.cityName
        : `${locationData.lng.toFixed(3)},${locationData.lat.toFixed(3)}`,
      isUseDefault
    };
  }
};

/**
 * 统一定位获取方法
 * 优先级：APP定位 -> 高德定位 -> 默认位置（广州市）
 * @returns Promise<{ lng: number, lat: number, address?: string, isUseDefault?: boolean }>
 */
export const getUnifiedLocation = async (): Promise<{
  lng: number;
  lat: number;
  address?: string;
  isUseDefault?: boolean;
}> => {

  // 如果在APP内，优先使用APP定位
  if (isXPApp) {
    try {
      const res = await requestLocation();
      console.log("getUnifiedLocation requestLocation from app -->", res);
      if (res.code === 0) {
        const locationData = {
          lng: res.data.coords.longitude,
          lat: res.data.coords.latitude
        };
        return await formatLocationResult(locationData, false);
      } else {
        throw new Error("APP定位失败");
      }
    } catch (err) {
      console.error("APP定位失败:", err);
      // APP定位失败，继续尝试Web定位
    }
  }

  // Web端定位（高德定位）
  try {
    const locationData = (await getLocationGeoPro()) as {
      lng: number;
      lat: number;
    };
    console.log("getLocationGeoPro", locationData);
    return await formatLocationResult(locationData, false);
  } catch (error) {
    console.error("Web定位失败:", error);

    // 定位失败时使用默认位置（广州市）
    const defaultLocation = { lng: defaultPoint.lng, lat: defaultPoint.lat };
    return await formatLocationResult(defaultLocation, true);
  }
};

const TRACE_STORAGE_KEY = 'charge_trace_id';
const TRACE_TTL = 24 * 60 * 60 * 1000; // 24h

interface TraceIdEntry {
  traceId: string;
  storedAt: number;
  /** 存储时的 UID，未登录时为空字符串 */
  uid: string;
}

/**
 * 同步获取当前有效的 UID，无效时返回空字符串
 */
function getTraceUid(): string {
  const uid = sessionStorage.getItem('sessionUid') || '';
  return uid;
}

/**
 * 存储 traceId 到 localStorage。
 * 不再依赖 UID 才能存储——未登录时也能存，登录后读取时校验归属。
 */
export function setTraceId(traceId: string): void {
  if (!traceId) return;
  try {
    const entry: TraceIdEntry = {
      traceId,
      storedAt: Date.now(),
      uid: getTraceUid(),
    };
    localStorage.setItem(TRACE_STORAGE_KEY, JSON.stringify(entry));
  } catch {
    // localStorage 写入失败
  }
}

/**
 * 获取当前用户的 traceId。
 * - 过期（24h）→ 清除并返回空字符串
 * - 存储时有 UID 且与当前 UID 不一致 → 说明切换了账号，清除并返回空字符串
 * - 存储时无 UID（未登录时写入）→ 视为属于当前用户，正常返回
 */
export function getTraceId(): string {
  try {
    const raw = localStorage.getItem(TRACE_STORAGE_KEY);
    if (!raw) return '';

    const entry: TraceIdEntry = JSON.parse(raw);

    // 检查是否过期（24小时）
    if (Date.now() - entry.storedAt >= TRACE_TTL) {
      localStorage.removeItem(TRACE_STORAGE_KEY);
      return '';
    }

    // 校验 UID 归属
    const currentUid = getTraceUid();
    if (entry.uid && currentUid && entry.uid !== currentUid) {
      // 存储时有明确 UID，且与当前用户不同 → 不属于当前用户
      localStorage.removeItem(TRACE_STORAGE_KEY);
      return '';
    }

    return entry.traceId;
  } catch (e) {
    console.error('解析 traceId 数据失败:', e);
  }
  return '';
}

/**
 * 清除 traceId
 */
export function clearTraceId(): void {
  try {
    localStorage.removeItem(TRACE_STORAGE_KEY);
  } catch {
    // ignore
  }
}
